import { CustomerDto, CustomersApiService, GetDataApiService, LoadingParamsUtils } from '@api';
import { AntDataResponse, AntSortLoadingParams } from '@antony/ng-ui';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ActiveCustomersService implements GetDataApiService<CustomerDto> {
  constructor(private api: CustomersApiService) {}

  getData(params: Partial<AntSortLoadingParams<CustomerDto>>): Observable<AntDataResponse<CustomerDto>> {
    return this.api
      .getPagedCustomersByInactiveState(
        LoadingParamsUtils.getSkipFrom(params),
        LoadingParamsUtils.getTakeFrom(params),
        LoadingParamsUtils.getFilterNamesFrom(params),
        LoadingParamsUtils.getFilterValueFrom(params),
        LoadingParamsUtils.getSortNamesFrom(params),
        LoadingParamsUtils.getApiSortDirection(params),
        false
      )
      .pipe(
        map((res) => ({
          data: res.data || [],
          maxCount: res.maxCount || 0,
        }))
      );
  }
}
